export * from './register';
import { POSITIONS_LABELS } from '@/utils/constants';
import { ResponseObtenerEquipoAnterior, TemplatePlayer } from './team';
import { Page } from './tda';
import { PopupVideoImagenTO } from './popupImageVideo';
import { PublicacionStatus } from '@/services/auth0';

// Generics

export type Maybe<T> = T | null;

export type Optional<T> = T | undefined;

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Optional<T[SubKey]>;
};

export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};

export type ValuesOf<T> = T[keyof T];
export type KeysOf<T> = keyof T;

export type PropsWithClassName<T = unknown> = T & {
  className?: string;
};

export type GetComponentProps<T> = T extends
  | React.ComponentType<infer P>
  | React.Component<infer P>
  ? P
  : never;

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

// End Generics
export enum EnumPosition {
  GK = 1,
  DEF,
  MID,
  FWD,
}

export type PositionAbbreviationsTypes =
  keyof typeof POSITIONS_LABELS.abbreviation;
export type PlayerPositionAbbr = PositionAbbreviationsTypes;
export type PlayerPositionAbbrF5 = PlayerPositionAbbr | 'ALL_FIELD_PLAYERS';

export enum ChangeTacticAction {
  DELETE,
  ADD,
  CHANGE,
}

export enum EnumDevice {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET',
}

export type NavigationItem = {
  name: string;
  href: string;
  icon?: React.ReactNode;
  highlight?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  isContrast?: boolean;
  children?: NavigationItem[];
  isActive?: boolean;
};

export type Size = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'auto';

export interface ModalActions {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
}

export type ShirtShieldProps = {
  startColor: string;
  endColor: string;
};

export const AUTH0_NETWORKS = {
  AUTH0: 'e-mail',
  LOCAL: 'e-mail',
  FACEBOOK: 'Facebook',
  FB: 'Facebook',
  GOOGLE: 'Google',
  APPLE: 'Apple',
  DESCONOCIDO: '',
  '': '',
  'GOOGLE-OAUTH2': 'Google',
} as const;

export const GENDER_ID = {
  hombre: 1,
  mujer: 2,
} as const;

export const ARG_OR_EXT = {
  arg: 'arg',
  ext: 'ext',
} as const;

export type Auth0ConfigResponse = {
  estado: true;
  clientId: string;
  domain: string;
  apiAudience?: string;
  hayPlaca?: Boolean;
  mensajePlaca?: string;
};

export type GDTApiErrors = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: false;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;

  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  pageInvitados?: Page;

  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  pagePart?: Page;
  remCSRF?: string;
};

export type GDTApiTimeout = {
  timeout?: boolean;
};

export type TournamentTeams = {
  id: number;
  nombre: string;
  nombreCorto: string;
};

export type DateGDT = {
  id: number;
  nombre: string;
  orden: number;
  isPublicada: boolean;
};

export type TeamPlayer = {
  id: number;
  titular: boolean;
  capitan: boolean;
};
export interface TemplatePlayerWithExtra extends TemplatePlayer {
  isSubstitute?: Maybe<boolean>;
}

export type TournamentStatus = {
  color: string;
  id: number;
  nombre: string;
};

export type MiniFixture = {
  loc: number;
  visit: number;
};

export interface SliderItem {
  titulo: string;
  bajada: string;
  urlImagen: string;
  idLinkeable: number;
  linkWebMobile?: string;
  linkAppMobile?: string;
  linkWebResponsive?: string;
}

export type OpcionEncuestaTO = {
  id?: number;
  descripcion?: string;
  totalVotos?: number;
  admiteTextoLibre?: boolean;
  admiteTextoLibre2?: boolean;
};

export type EncuestaTO = {
  id?: number;
  titulo?: string;
  consigna?: string;
  opcionMultiple?: boolean;
  idTipoEncuesta?: string;
  tipoEncuesta?: string;
  totalVotos?: number;
  opciones?: OpcionEncuestaTO[];
};

export interface UserInitialData {
  fotoPerfil?: string;
  primera_fecha: boolean;
  pase_id?: string;
  resultadoCambioPosicionGral: number;
  slider: SliderItem[];
  sliderResponsive: SliderItem[];
  resultadoCambioPosicionLocalidadGral: number;
  resultadoCambioPosicionLocalidadFecha: number;
  recibeInformacion?: boolean;
  pathImagenPerfil?: string;
  resultadoCambioPosicionFecha: number;
  tiene_equipo_f5: boolean;
  // estaPubLaUltJDeF5: boolean; eliminada
  estado: true;

  nombre_dt: string;
  mail: string;
  encuesta: EncuestaTO;
  puedeVotar: boolean;
  // offsetFechas: number;
  tiene_equipo: boolean;
  equipos_torneo: TournamentTeams[];
  fechaMostrarRankingF5: DateGDT;
  fechaMostrarRankingF11: DateGDT;
  fechas_disponibles_f5_obj: DateGDT[];
  // popups: PopupVideoImagenTO[];(filtra solo MOBILE)
  popups_resp: PopupVideoImagenTO[];
  puntos_fecha: number;
  transferencias_fecha: number;
  nombre_equipo: string;
  anioMaximoRegistracion: number;
  path_escudo: string;
  jsReportCrashes: boolean;
  fecha: number;
  csrfToken: string;
  plantilla: {
    jugadores: TemplatePlayer[];
    miniFixture: MiniFixture[];
  };
  status_torneo: TournamentStatus[];

  fechaActiva: DateGDT;
  fecha_publicada: boolean;
  fechas_disponibles_f5: unknown[];
  posicion_fecha: number;
  // tiendaAuspiciante: boolean;
  todoPublicado: boolean;
  todasLasFechas: DateGDT[];
  isFechaTransferenciasGratis: boolean;
  diferenciaPosicionFecha: number;
  pinesDisponibles: number;
  provincia: string;
  barrio: string;
  // segmPinesUsados: number;
  // cant_transf_fecha: number;
  modoRegistracion: string;
  fechas_disponibles_obj: DateGDT[];
  idSexo: string;
  club_hincha: string;
  premium: boolean;
  // gdt_pub_id: string;
  veda: boolean;
  path_camiseta: string;
  posicion_general: number;
  fechas_disponibles: number[];
  enableAutocomplete: boolean;
  comienzo_veda: string; // Example: "01/09/2023 00:00"
  //centralSCN: string; // example "6352_5654_5361_0_13021919_0"
  puntos_general: number;
  presupuesto_total: number;
  // arraySugerenciaTO: unknown[];
  id_ult_fecha_puntos: number;
  saldo: number;
  equipo: {
    jugadores: TeamPlayer[];
  };
  idUsuarioDT: number;
  esAceptableInscripcionTA: boolean;
  autoregistrado: boolean;
  camiseta_svg: string; // example "2,9,ffffff,4d18df,4"
  escudo_svg: string; // example "2,9,ffffff,4d18df,4"
  nombre_fecha: string; // example: "Fecha 21"
  dtExtranjero: boolean;
  edad_dt?: number;
  prevTeam?: ResponseObtenerEquipoAnterior;
  rankingLocalidad?: {
    idLocalidad: number;
    nombreLocalidad: string;
    posicionFecha: number;
    posicionGeneral: number;
  };
  infoRankingProvincia: {
    posicionFecha: number;
    posicionGeneral: number;
    posicionGeneralAnterior: number;
    nombreProvincia: string;
  };
  showTDAP?: boolean;
  paginaInicial: {
    linkWebResponsive: string;
  };
  diferenciaPosicionGral?: number;
  diferenciaPosicionLocalidadGral?: number;
  diferenciaPosicionLocalidadFecha?: number;
  torneo: string;
  uvr: PublicacionStatus;
}

export interface SelectValue {
  label: string;
  value: number;
  disabled?: boolean;
}

export interface DataPostRecoverEmail {
  docNumber: string;
  selectedTypeDoc: SelectValue;
  errorMsg?: string;
}

export interface ResponseRecoverEmail {
  estado: true;
  mensaje: string;
  error: Err;
  emailsRecuperacion: EmailsRecuperated[];
  codError: number;
}

export interface EmailsRecuperated {
  emailDistorsionado: string;
  esPaseConAlgunaSocial: false;
  idAuth0: string;
  origen: string;
  docNumber?: string;
}

export interface Err {
  msg?: string;
  code?: number;
}

export interface Sugerencias {
  id: number;
  mejores_posibles: number[];
  ult_transferidos: number[];
  idGrupo: number;
  promedio: number;
}

export type GenderValues = ValuesOf<typeof GENDER_ID>;
export type DocumentTypesValues = ValuesOf<typeof ARG_OR_EXT>;
